import { Eyebrow, SectionHeading } from "../common/Type";
import { RevealStagger, RevealItem } from "../common/Reveal";
import { businessImpact } from "../../lib/content";

export default function BusinessImpact() {
  return (
    <section className="relative py-24 md:py-32 bg-kv-bg2/40 border-y border-kv-steel/10" data-testid="section-impact">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-16">
          <Eyebrow className="mb-5">Business impact</Eyebrow>
          <SectionHeading>Outcomes that compound across the operation.</SectionHeading>
        </div>

        <RevealStagger className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-8">
          {businessImpact.map((item, i) => (
            <RevealItem key={item} className="border-t border-kv-steel/20 pt-5">
              <span className="block h-1 w-7 bg-kv-electric/80 mb-3" aria-hidden />
              <p className="font-display text-lg md:text-xl tracking-tight text-kv-off leading-snug">{item}</p>
            </RevealItem>
          ))}
        </RevealStagger>
      </div>
    </section>
  );
}
